module.exports = __webpack_public_path__ + "img/Display-Ad-Disrupt-Video-Icons.7099bd0b.jpg";